module.exports = __webpack_public_path__ + "static/media/houstonfood-logo.90f53f84.png";